import React, { useState } from "react";
import { Column } from "primereact/column";
import { DataTable, DataTableExpandedRows } from "primereact/datatable";
import ScenarioStore from "../../store/ScenarioStore";
import { observer } from "mobx-react";
import { Scenario } from "../../api/firebase/types/scenario.types";
import ScenarioExpansionTemplate from "./scenarioSettings/ScenarioExpansionTemplate";
import { AlarmCategoryTemplate } from "../../components/templates/AlarmCategoryTemplate";

type ScenarioTableProps = {
  selectedScenarios?: Scenario[];
  setSelectedScenarios: (scenarios: Scenario[]) => void;
};

const ScenarioTable: React.FC<ScenarioTableProps> = ({
  selectedScenarios,
  setSelectedScenarios,
}) => {
  const [expandedRows, setExpandedRows] = useState<
    any[] | DataTableExpandedRows
  >([]);

  const scenarios = ScenarioStore.scenarios;

  return (
    <DataTable
      size="large"
      value={scenarios}
      dataKey="id"
      emptyMessage="Keine Szenarien vorhanden"
      selection={selectedScenarios}
      onSelectionChange={(e) => setSelectedScenarios(e.value)}
      expandedRows={expandedRows}
      onRowToggle={(e) => setExpandedRows(e.data)}
      rowExpansionTemplate={(scenario) => (
        <ScenarioExpansionTemplate scenario={scenario} />
      )}
    >
      <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
      <Column expander style={{ width: "3em" }} />
      <Column field="title" header="Bezeichnung" sortable />
      <Column
        field="emergencyCall"
        header="Notrufleitstelle"
        body={(scenario) => AlarmCategoryTemplate(scenario.emergencyCall)}
      />
      <Column
        field="contactDeviceContacts"
        header="Meldeinstanz-Kontakte"
        body={(scenario) => (
          <div>{scenario.contactDeviceContacts ? "Ja" : "Nein"}</div>
        )}
      />
    </DataTable>
  );
};

export default observer(ScenarioTable);
